import { all, takeEvery, select, call, put } from "@redux-saga/core/effects";
import actionTypes from "../actions/actionTypes";
import { geoBaseUrl, httpClient } from "../../http-client/http-client";
import { geoActions } from "../actions/geo/geo";

const accessTokenSelector = state => state.oidc.user.access_token;
const languageSelector = state => state.settings.language;

function* fetchCountries(action) {
  const accessToken = yield select(accessTokenSelector);
  const language = yield select(languageSelector);
  const url = `${geoBaseUrl}/countries/${language}`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(
      geoActions.fetchCountriesOk(data.Countries, data.EstimatedCountryIsoCode)
    );
  } catch (error) {
    yield put(geoActions.fetchCountriesError(error));
  }
}

export function* watchGeo() {
  yield all([
    takeEvery(actionTypes.geo.FETCH_COUNTRIES, fetchCountries)
  ]);
}
